import { Component, OnInit, ViewChild } from '@angular/core';
import { SistemaProvaService } from '@app/services/prova-online.service';
import Swal from 'sweetalert2';
import { environment } from '@env/environment';
import { CountdownComponent } from 'ngx-countdown';


@Component({
  selector: 'app-prova-online',
  templateUrl: './prova-online.component.html',
  styleUrls: ['./prova-online.component.scss'],
  inputs:['cpfCandidato:cpf-candidato','notificacao:notificacao']
})
export class ProvaOnlineComponent implements OnInit {
  @ViewChild('cd', { static: false }) private countdown: CountdownComponent;

  cpfCandidato: string;
  notificacao = false;
  public provasQueEstaoAcontecendo;
  public listaProvas = [];

  constructor(private _sistemaProvaService: SistemaProvaService) { }

  ngOnInit() {
    this.buscarProvas().then(() => {
      this.provasQueEstaoAcontecendo = this.buscarProvasQueEstaoAcontecendo();
    });
  }

  /**
   * Busca todas as provas que serão aplicadas para aquele candidato
   * @returns
   */
  buscarProvas(){

    var promise = new Promise((resolve) => {
      this._sistemaProvaService.buscarProvas(this.cpfCandidato).subscribe(result =>{

        this.listaProvas = result;

        resolve(result);

      });
    });

    return promise;

  }

  /**
   * Busca a proxima prova a ser aplicada do candidato
   * @returns
   */
  buscarProximaProva(){
   if(this.listaProvas != null){
    var proximaProva = this.listaProvas.filter(function (prova) {
      return prova.primeiraprova === true;
    });

    return proximaProva[0];
   }
   return null;

 }

 buscarProvasQueEstaoAcontecendo(){
  var provas = null;
  if(this.listaProvas != null){
    provas = this.listaProvas.filter(function (prova) {
      return prova.podeacessarprova == true;
    });
  }

  return provas;

 }

 /**
  * Mensagem para informar ao candidato que ele tem uma prova para fazer
  */
 avisoParaIniciarProva(){

    Swal.fire({
      title: 'Atenção!',
      text: 'Você tem uma prova para ser realizada, deseja acessa-la agora?',
      icon: 'warning',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Sim, quero fazer minha prova agora!',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {

        var prova = this.buscarProvaQueEstaAcontecendo();
        this.acessarProva(prova.token);

      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Você decidiu que não deseja acessar sua prova agora',
            'Quando estiver pronto para fazer sua prova, clique no botão Acessar Prova. Mas lembre-se você só poderá fazer esta prova até as 20:00hs de hoje.',
            'error'
          );

      }
    });

  this.buscarProvas();

 }

 /**
  * Mensagem para informar ao candidato que ele tem várias provas pra fazer
  */
 avisoParaIniciarVariasProvas(){

    Swal.fire(
      'Atenção!',
      'Você tem várias provas para fazer. Escolha a prova que você deseja fazer clicando no botão acessar prova',
      'info'
    )

    this.buscarProvas();

  }

  acessarProva(token){

    window.open(
      environment.url_api_sistema_prova+'/acessarprova.php?token='+token,
      '_blank'
    );

  }

  buscarProvaQueEstaAcontecendo(){
    var prova = this.buscarProvasQueEstaoAcontecendo();
    if(prova.length == 1){
      return prova[0];
    }
  }

  mostrarMensagemInicioProva(){
    this.buscarProvas().then((result) => {
      var listaProvasEmAndamento = this.buscarProvasQueEstaoAcontecendo();

      if(listaProvasEmAndamento.length == 1){
        this.avisoParaIniciarProva();
      }
      else if(listaProvasEmAndamento.length > 1){
        this.avisoParaIniciarVariasProvas();
      }

    });
  }

  /**
   * Evento que monitora o timer
   */
  contadorProva(event){

      if(event.action == 'done'){
        if(event.left == 0){
          this.mostrarMensagemInicioProva();
        }
      }
  }

}
